import { cn } from '@/utils'
import type { MapLane } from './map'
import { GRID, MONTH_GAP, TRACK_HEIGHT } from './mapLayout'
import { DROPPING_ON, type MapActions, TARGET_UNDER_POINTER } from './mapView'

interface EmptyLaneStripProps {
  lane: MapLane
  choosing: boolean
  actions: MapActions
}

// Pages carry their own dates, so an account with no statement yet needs no months to drop on.
export const EmptyLaneStrip = ({
  lane,
  choosing,
  actions,
}: EmptyLaneStripProps) => (
  <div
    className={cn('grid items-center', MONTH_GAP)}
    style={{ gridTemplateColumns: GRID, gridTemplateRows: TRACK_HEIGHT }}
  >
    <button
      type="button"
      data-drop-target
      onClick={() =>
        actions.onPutInNew({ accountId: lane.accountId, period: null })
      }
      className={cn(
        'h-8 cursor-pointer rounded-md border border-dashed border-border text-xs text-ink-subtle transition-colors hover:bg-neutral-200 hover:text-foreground',
        choosing && TARGET_UNDER_POINTER,
        DROPPING_ON,
      )}
      style={{ gridColumn: '2 / -1' }}
      title={
        choosing
          ? `Put the selected pages under ${lane.label}. They keep their own dates.`
          : `Pick pages to file them under ${lane.label}`
      }
    >
      No statements yet. Drop pages here.
    </button>
  </div>
)
